import "./ButtonPanel.scss";

import {PropsWithChildren, ReactNode} from "react";
import {AlignmentType, StackPanel} from "../panels/StackPanel";
import classNames from "classnames";

export interface ButtonPanelProps {
    buttons: ReactNode;

    className?: string;
    buttonsClassName?: string;
    fill?: boolean;
    fillContent?: boolean;

    buttonLocation?: "top" | "bottom";

    align?: AlignmentType;
}

export const ButtonPanel = ({
                                buttons,
                                className,
                                buttonsClassName,
                                fill,
                                fillContent,
                                align,
                                buttonLocation,
                                children,
                            }: ButtonPanelProps & PropsWithChildren) => {
    return (
        <StackPanel className={classNames("button-panel", buttonLocation || "bottom")}
                    orientation="vertical"
                    fill={fill}>

            <div className={classNames("content", className)}>
                {children}
            </div>

            {buttons && <StackPanel className={classNames("buttons", buttonsClassName)}
                        orientation="horizontal"
                        align={align ?? "middle"}
                        fill={fillContent}>
                {buttons}
            </StackPanel>}
        </StackPanel>
    );
};
